// extracted by mini-css-extract-plugin
export default {"tupacGrid":"yp-z","tupacHeader":"zp-z","tupacHeader2":"Ap-z","tupacMenu":"Bp-z","tupacMenu2":"Cp-z","tupacMain":"Dp-z","tupacMain2":"Ep-z"};